import React,{useContext} from 'react';
import TimeTableContext from '../../context/timeTableContext'

const SelectClass = () => {
    const context = useContext(TimeTableContext);
    
    
    return ( 
        <div className="form-group">
            <select onChange={(e) => {context.dispatch({type:"SET_CLASS",payload:e.target.value}) }} className="form-control" id="exampleFormControlSelect1">
            <option value={""}>בחר כיתה</option>
            
            {
                context.state.classes.map( (cls) => {
                    let selected = cls._id === context.state.classId ? "selected" : "";
                    return(
                        <option key={cls._id} value={cls._id} selected={selected}>
                            {cls.name}
                        </option>
                    )
                }) 
            }
            
            </select>
        </div>
     );
}
 
export default SelectClass;